export const fromTrainsBtn = document.getElementById('from_trains_button');
export const toTrainsBtn = document.getElementById('to_trains_button');
const cityFromElement = document.querySelector('.city-from');
const cityToElement = document.querySelector('.city-to');
const postId = jQuery('.trains-types').data('post-id');

if(issetUrlParamArrival()) {
    setActiveArrival();
}
else {
    if(window.location.href.indexOf("/gorod/") > 0) {
        if(jQuery('.city-from').find("header").length === 0) {
            jQuery('.result__header').hide();
        }
        else {
            jQuery('.result__header').show();
        }
    }
}

export function fromTrainsShow() {
    fromTrainsBtn.classList.add('all__active', 'trains-all__active')
    toTrainsBtn.classList.remove('all__active', 'trains-all__active')

    cityToElement.classList.remove('d-none');
    cityFromElement.classList.add('d-none');

    if(!issetUrlParamArrival()) {
        history.pushState(null, null, window.location.href + '?arrival');
    }

    setActiveArrival();
}

export function toTrainsShow() {
    toTrainsBtn.classList.add('all__active', 'trains-all__active')
    fromTrainsBtn.classList.remove('all__active', 'trains-all__active')

    cityFromElement.classList.remove('d-none');
    cityToElement.classList.add('d-none');

    if(issetUrlParamArrival()) {
        const urlAll = window.location.href;
        history.pushState(null, null, urlAll.replace(/(\?arrival.*)/, ''));
    }

    jQuery('.city-from').show();
    jQuery('.city-to').hide();
}

function issetUrlParamArrival() {
    const urlParams = new URLSearchParams(window.location.search);
    const arrivalParam = urlParams.get('arrival');

    if(arrivalParam === null || arrivalParam === undefined) {
        return false;
    }

    return true;
}

function setActiveArrival() {

    jQuery('#to_trains_button').removeClass("trains-all__active");
    jQuery('#from_trains_button').addClass("trains-all__active");

    jQuery('.city-head h2').html('Расписание прибытия поездов на станцию ' + jQuery('h1').text().split(':')[0] + ' на сегодня');

    jQuery('.city-to').show();
    jQuery('.city-from').hide();

    if (jQuery('.city-to').is(':empty')){

        jQuery('.city-to').html('<div class="div_arrival_loader" style="text-align: center; margin-top: 20px;"><span class="arrival_loader"></span></div>')

        jQuery('.result__header').show();

        jQuery.get('/api/departures?city_id=' + postId + '&route=' + encodeURI(window.location.href), function (response) {
            jQuery('.div_arrival_loader').remove();

            let cityTo = jQuery('.city-to');
            cityTo.html(response);

            if(cityTo.find("header").length === 0) {
                jQuery('.result__header').hide();
            }
            else {
                cityTo.removeClass('d-none');
                jQuery('.result__header').show();
            }
        }, 'JSON');
    }
}
